import Vue from "vue";
import VuetifyConfirm from "vuetify-confirm";

Vue.use(VuetifyConfirm, {
	buttonTrueText: "Tak",
	buttonFalseText: "Nie",
	color: "warning",
	icon: "warning",
	title: "Warning",
	width: 350,
	property: "$confirm",
});
